import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aa8ff9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm ecran-container-oferta" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"display":"flex","flex-direction":"row","align-items":"center","gap":"1rem","cursor":"pointer"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"black","font-weight":"bold","margin-bottom":"8px"} }, "Observatii:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = {
  key: 1,
  class: "app__property--medium",
  style: {"display":"flex","justify-content":"flex-start"}
}
const _hoisted_12 = {
  key: 2,
  class: "header__container"
}
const _hoisted_13 = {
  style: {"display":"grid","grid-template-columns":"1fr 1fr"},
  class: "header__text"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nr.pozitii", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = { style: {"text-align":"right"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cantitate totala", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = { style: {"text-align":"right"} }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valabilitate Oferta", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = { style: {"text-align":"right","color":"red"} }
const _hoisted_24 = {
  style: {"display":"grid","grid-template-columns":"1fr 1fr"},
  class: "header__text"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total fara TVA", -1))
const _hoisted_26 = { style: {"text-align":"right"} }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total TVA", -1))
const _hoisted_28 = { style: {"text-align":"right"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Disc Linii", -1))
const _hoisted_30 = { style: {"text-align":"right"} }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Disc Oferta", -1))
const _hoisted_32 = { style: {"text-align":"right"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total", -1))
const _hoisted_34 = { style: {"text-align":"right"} }
const _hoisted_35 = { style: {"display":"flex","justify-content":"flex-end","padding-bottom":"1rem"} }
const _hoisted_36 = { style: {"background-color":"white"} }
const _hoisted_37 = { style: {"grid-area":"img","display":"flex","flex-direction":"row"} }
const _hoisted_38 = { style: {"display":"flex","align-items":"center","flex-direction":"column","gap":"2px"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute-full flex flex-center bg-negative text-white" }, " Cannot load image ", -1))
const _hoisted_40 = { class: "produs_detalii" }
const _hoisted_41 = { class: "app__property--medium" }
const _hoisted_42 = {
  class: "app__color--blue",
  style: {"font-weight":"bold"}
}
const _hoisted_43 = {
  class: "app__color--semigray",
  style: {"font-weight":"lighter"}
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 2 }
const _hoisted_47 = { key: 3 }
const _hoisted_48 = { key: 4 }
const _hoisted_49 = { key: 5 }
const _hoisted_50 = { key: 6 }
const _hoisted_51 = {
  key: 0,
  class: "app__color--semigray",
  style: {"font-weight":"lighter"}
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/_createTextVNode()
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  key: 1,
  class: "app__color--semigray",
  style: {"font-weight":"lighter","font-style":"italic"}
}
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { style: {"display":"flex","flex-direction":"column","grid-area":"quantity"} }
const _hoisted_59 = {
  key: 0,
  style: {"min-width":"110px","min-height":"25px"}
}
const _hoisted_60 = {
  key: 1,
  style: {"min-width":"110px","min-height":"25px"}
}
const _hoisted_61 = {
  key: 2,
  style: {"min-width":"110px","min-height":"25px"}
}
const _hoisted_62 = {
  key: 3,
  style: {"min-width":"110px","min-height":"25px"}
}
const _hoisted_63 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column","grid-area":"price"}
}
const _hoisted_64 = {
  key: 0,
  class: "app__money__value--large",
  style: {"min-width":"110px","min-height":"25px"}
}
const _hoisted_65 = {
  key: 1,
  class: "app__money__value--large",
  style: {"min-width":"110px","min-height":"25px"}
}
const _hoisted_66 = {
  key: 2,
  style: {"min-width":"110px","min-height":"25px"}
}
const _hoisted_67 = {
  key: 3,
  class: "app__money__value--large",
  style: {"min-width":"110px","min-height":"25px"}
}
const _hoisted_68 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column","grid-area":"value"}
}
const _hoisted_69 = { class: "app__money__value--large" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Termen de livrare", -1))
const _hoisted_71 = {
  key: 2,
  style: {"min-width":"110px","min-height":"25px","grid-area":"value"}
}
const _hoisted_72 = { class: "app-center-content-horizontal" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode("Download")
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrowseCategories = _resolveComponent("BrowseCategories")!
  const _component_BrowseArticles = _resolveComponent("BrowseArticles")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_EditQuantityArticleCerere = _resolveComponent("EditQuantityArticleCerere")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showBrowseArticles)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.pidForBrowseCategoryHasArticles)
            ? (_openBlock(), _createBlock(_component_BrowseCategories, {
                key: 0,
                pid: _ctx.pidForBrowseCategory,
                typeOfAccess: 'fromOferta'
              }, null, 8, ["pid"]))
            : _createCommentVNode("", true),
          (_ctx.pidForBrowseCategoryHasArticles)
            ? (_openBlock(), _createBlock(_component_BrowseArticles, {
                key: 1,
                pidCategory: _ctx.pidForBrowseCategory,
                typeOfAccess: 'fromOferta'
              }, null, 8, ["pidCategory"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_q_btn, {
              icon: "event_repeat",
              label: "Repeta oferta pentru o noua cerere",
              color: "blue",
              "no-caps": "",
              onClick: _ctx.repetaCerere,
              style: {"margin-top":"1rem"}
            }, null, 8, ["onClick"])
          ]),
          _hoisted_5,
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'div_card_mobile' : 'div_card_desktop')
          }, [
            _createVNode(_component_q_input, {
              outlined: "",
              modelValue: _ctx.nrComandaCerere,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nrComandaCerere) = $event)),
              label: _ctx.changedItemsInOffer ? 'Nr. cerere' : 'Nr. comanda',
              counter: "",
              maxlength: "20",
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);')
            }, null, 8, ["modelValue", "label", "style"]),
            (_ctx.changedItemsInOffer)
              ? (_openBlock(), _createBlock(_component_q_input, {
                  key: 0,
                  outlined: "",
                  modelValue: _ctx.termenCerere,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.termenCerere) = $event)),
                  mask: "####-##-##",
                  label: "Termen de livrare solicitat",
                  style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
                  "input-style": { fontWeight: 'bolder' }
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "event",
                      class: "cursor-pointer"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_q_popup_proxy, {
                      ref: "qDateProxy0",
                      "transition-show": "scale",
                      "transition-hide": "scale"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_date, {
                          modelValue: _ctx.termenCerere,
                          "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.termenCerere) = $event)),
                            _cache[2] || (_cache[2] = () => _ctx.$refs.qDateProxy0.hide())
                          ],
                          mask: "YYYY-MM-DD",
                          locale: _ctx.myLocale,
                          options: _ctx.optionsDataViitor
                        }, null, 8, ["modelValue", "locale", "options"])
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                }, 8, ["modelValue", "style"]))
              : _createCommentVNode("", true),
            _createVNode(_component_q_select, {
              outlined: "",
              label: "Adresa de livrare",
              modelValue: _ctx.slidAdresaLivrare,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.slidAdresaLivrare) = $event)),
              "option-value": "slid",
              "option-label": "adresaAdresa",
              options: _ctx.adrese,
              "emit-value": "",
              "map-options": "",
              "options-selected-class": "text-deep-orange",
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);')
            }, {
              option: _withCtx((scope) => [
                _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, {
                          caption: scope.opt.isNewAddress == '1'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.opt.adresaLocalitate), 1)
                          ]),
                          _: 2
                        }, 1032, ["caption"]),
                        _createVNode(_component_q_item_label, { caption: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.opt.adresaAdresa), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 1
            }, 8, ["modelValue", "options", "style"]),
            (!_ctx.changedItemsInOffer)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  disable: _ctx.changedItemsInOffer,
                  flat: "",
                  color: "primary",
                  align: "center",
                  "no-caps": "",
                  label: "Ro",
                  icon: "picture_as_pdf",
                  loading: _ctx.downloadingFile,
                  style: {"min-width":"4rem","max-width":"4rem"},
                  onClick: _ctx.generareOfertaPDFRO
                }, null, 8, ["disable", "loading", "onClick"]))
              : _createCommentVNode("", true),
            (!_ctx.changedItemsInOffer)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 2,
                  disable: _ctx.changedItemsInOffer,
                  flat: "",
                  color: "primary",
                  align: "center",
                  "no-caps": "",
                  label: "Eng",
                  icon: "picture_as_pdf",
                  loading: _ctx.downloadingFile,
                  style: {"min-width":"4rem","max-width":"4rem"},
                  onClick: _ctx.generareOfertaPDFENG
                }, null, 8, ["disable", "loading", "onClick"]))
              : _createCommentVNode("", true)
          ], 2),
          _hoisted_6,
          (_ctx.inputFreeTextComments.length>0 || _ctx.changedItemsInOffer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_q_input, {
                  maxlength: "250",
                  type: "textarea",
                  autogrow: "",
                  counter: "",
                  class: "input--desire",
                  outlined: "",
                  modelValue: _ctx.inputFreeTextComments,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputFreeTextComments) = $event)),
                  placeholder: "Detalii cerere noua",
                  dense: "",
                  color: "blue-grey-7"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_9,
          _hoisted_10,
          (_ctx.offerHeader.status=='k')
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Comanda trimisa la data " + _toDisplayString(_ctx.offerHeader.trackDateAccept.substr(0,10)) + " ora " + _toDisplayString(_ctx.oraAcceptOffer), 1))
            : _createCommentVNode("", true),
          (!_ctx.changedItemsInOffer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.productsFromSales.length), 1),
                  _hoisted_17,
                  _hoisted_18,
                  _createElementVNode("span", _hoisted_19, _toDisplayString(Number(_ctx.offerHeader.qKg).toFixed(2)) + " Kg", 1),
                  (_ctx.offerHeader.status=='o')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _hoisted_21,
                        _hoisted_22,
                        _createElementVNode("span", _hoisted_23, " expira " + _toDisplayString(_ctx.timeUntilFutureDate(_ctx.offerHeader.dateWhenOfferExpire,'YYYY-MM-DD HH:mm')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.offerHeader.idValuta == 'RON' ? Number(_ctx.offerHeader.valFinalaFaraTvaRON).toFixed(2) : _ctx.offerHeader.idValuta == 'EUR' ? Number(_ctx.offerHeader.valFinalaFaraTvaEUR).toFixed(2) : Number(_ctx.offerHeader.valFinalaCuTvaHUF).toFixed(2)) + " " + _toDisplayString(_ctx.offerHeader.idValuta), 1),
                  _hoisted_27,
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.offerHeader.idValuta == 'RON' ? Number(_ctx.offerHeader.valTvaRON).toFixed(2) : _ctx.offerHeader.idValuta == 'EUR' ? Number(_ctx.offerHeader.valTvaEUR).toFixed(2) : Number(_ctx.offerHeader.valTvaHUF).toFixed(2)) + " " + _toDisplayString(_ctx.offerHeader.idValuta), 1),
                  _hoisted_29,
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.offerHeader.idValuta == 'RON' ? Number(_ctx.offerHeader.val_discount_linii_ron).toFixed(2) : _ctx.offerHeader.idValuta == 'EUR' ? Number(_ctx.offerHeader.val_discount_linii_eur).toFixed(2) : Number(_ctx.offerHeader.val_discount_linii_huf).toFixed(2)) + " " + _toDisplayString(_ctx.offerHeader.idValuta), 1),
                  _hoisted_31,
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.offerHeader.idValuta == 'RON' ? Number(_ctx.offerHeader.val_discount_oferta_ron).toFixed(2) : _ctx.offerHeader.idValuta == 'EUR' ? Number(_ctx.offerHeader.val_discount_oferta_eur).toFixed(2) : Number(_ctx.offerHeader.val_discount_oferta_huf).toFixed(2)) + " " + _toDisplayString(_ctx.offerHeader.idValuta), 1),
                  _hoisted_33,
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.offerHeader.idValuta == 'RON' ? (Number(_ctx.offerHeader.valFinalaCuTvaRON) - Number(_ctx.offerHeader.val_discount_linii_ron) - Number(_ctx.offerHeader.val_discount_oferta_ron)).toFixed(2) 
                  : _ctx.offerHeader.idValuta == 'EUR' ? (Number(_ctx.offerHeader.valFinalaCuTvaEUR) - Number(_ctx.offerHeader.val_discount_linii_eur) - Number(_ctx.offerHeader.val_discount_oferta_eur)).toFixed(2) 
                  : (Number(_ctx.offerHeader.valFinalaCuTvaHUF) - Number(_ctx.offerHeader.val_discount_linii_huf) - Number(_ctx.offerHeader.val_discount_oferta_huf)).toFixed(2)) + " " + _toDisplayString(_ctx.offerHeader.idValuta), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_35, [
            (_ctx.offerHeader.status=='o' && !_ctx.isOfferExpired && !_ctx.changedItemsInOffer)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  color: "blue",
                  size: "sm",
                  unelevated: "",
                  "icon-right": "send",
                  label: "Trimite Comanda",
                  onClick: _ctx.sendAcceptForOffer
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.changedItemsInOffer)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  color: "blue",
                  label: "Cere oferta noua",
                  "no-caps": "",
                  onClick: _ctx.trySendCerereForAnOffer
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_36, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsFromSales, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.appid,
                class: "product__container"
              }, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_q_btn, {
                      flat: "",
                      icon: "arrow_drop_up",
                      onClick: ($event: any) => (_ctx.moveUP(index))
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(index+1), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_btn, {
                      flat: "",
                      icon: "arrow_drop_down",
                      onClick: ($event: any) => (_ctx.moveDown(index))
                    }, null, 8, ["onClick"])
                  ]),
                  _createVNode(_component_q_img, {
                    transition: "fade",
                    src: _ctx.urlToJPG+'/'+item.categoryPid,
                    ratio: "1",
                    fit: "scale-down",
                    "spinner-color": "light-blue",
                    class: "rounded-borders shopping_cart--img shadow-1"
                  }, {
                    error: _withCtx(() => [
                      _hoisted_39
                    ]),
                    _: 2
                  }, 1032, ["src"])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("span", _hoisted_41, _toDisplayString(item.productName), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.chainCategories(item.categoryPid)), 1),
                  _createElementVNode("span", _hoisted_42, "Cod:" + _toDisplayString(item.productCode), 1),
                  _createElementVNode("span", _hoisted_43, [
                    (item.l)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Lungime " + _toDisplayString(item.l) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.w)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Latime " + _toDisplayString(item.w) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.t)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_46, "Grosime " + _toDisplayString(item.t) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.d)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Diametru " + _toDisplayString(item.d) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.h)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Inaltime " + _toDisplayString(item.h) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.a)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Aliaj " + _toDisplayString(item.a), 1))
                      : _createCommentVNode("", true),
                    (item.k)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Tip " + _toDisplayString(item.k), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (item.cuDebitare && item.cuDebitare=='y')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                        _createTextVNode(_toDisplayString(item.nrBuc) + " bucati cu debitare la ", 1),
                        (item.sizeLengthFromSales)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Lungimea " + _toDisplayString(item.sizeLengthFromSales) + " mm ", 1))
                          : _createCommentVNode("", true),
                        _hoisted_53,
                        (item.sizeWidthFromSales)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_54, "Latimea " + _toDisplayString(item.sizeWidthFromSales) + " mm ", 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (item.observatii)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_55, "Obs: " + _toDisplayString(item.observatii), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_q_btn, {
                        icon: "edit",
                        label: "Modificare cantitate",
                        outline: "",
                        color: "green",
                        "no-caps": "",
                        size: "sm",
                        style: {"margin-right":"1em"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_popup_proxy, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_banner, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_EditQuantityArticleCerere, {
                                    item: _ctx.ItemForEdit(item),
                                    index: index,
                                    onEditItem: _ctx.onEditItem
                                  }, null, 8, ["item", "index", "onEditItem"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      (_ctx.$q.platform.is.mobile)
                        ? (_openBlock(), _createElementBlock("br", _hoisted_56))
                        : _createCommentVNode("", true),
                      (_ctx.$q.platform.is.mobile)
                        ? (_openBlock(), _createElementBlock("br", _hoisted_57))
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_btn, {
                        icon: "delete_forever",
                        label: "Sterge articol",
                        outline: "",
                        color: "red",
                        size: "sm",
                        "no-caps": "",
                        onClick: ($event: any) => (_ctx.removeArticle(index))
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  (item.tip_um == 'um1' || item.tip_um == 'um12')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(item.q1.toFixed(2)) + " " + _toDisplayString(item.um1), 1))
                    : _createCommentVNode("", true),
                  (item.tip_um == 'um2' || item.tip_um == 'um12')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(item.q2.toFixed(2)) + " " + _toDisplayString(item.um2), 1))
                    : _createCommentVNode("", true),
                  (_ctx.$q.platform.is.mobile && !item.itemChanged)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Suma totala"))
                    : _createCommentVNode("", true),
                  (_ctx.$q.platform.is.mobile && !item.itemChanged)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_62, "Termen de livrare"))
                    : _createCommentVNode("", true)
                ]),
                (!item.itemChanged)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      (item.tip_um == 'um1' || item.tip_um == 'um12')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(_ctx.offerHeader.idValuta == 'RON' ? Number(item.pretMediuCalculatUM1RON).toFixed(2) 
                  : _ctx.offerHeader.idValuta == 'EUR' ? Number(item.pretMediuCalculatUM1EUR).toFixed(2)  
                  : Number(item.pretMediuCalculatUM1HUF).toFixed(2)) + " " + _toDisplayString(_ctx.offerHeader.idValuta) + " / " + _toDisplayString(item.um1), 1))
                        : _createCommentVNode("", true),
                      (item.tip_um == 'um2' || item.tip_um == 'um12')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.offerHeader.idValuta == 'RON' ? Number(item.pretMediuCalculatUM2RON).toFixed(2) 
                  : _ctx.offerHeader.idValuta == 'EUR' ? Number(item.pretMediuCalculatUM2EUR).toFixed(2) 
                  : Number(item.pretMediuCalculatUM2HUF).toFixed(2)) + " " + _toDisplayString(_ctx.offerHeader.idValuta) + " / " + _toDisplayString(item.um2), 1))
                        : _createCommentVNode("", true),
                      (item.discount_proc > 0 && _ctx.$q.platform.is.desktop)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, "-" + _toDisplayString(item.discount_proc) + " %", 1))
                        : _createCommentVNode("", true),
                      (_ctx.$q.platform.is.mobile && item.appid!='0')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.offerHeader.idValuta == 'RON' ? Number(item.valFinalaFaraTvaRON).toFixed(2) : _ctx.offerHeader.idValuta == 'EUR' ? Number(item.valFinalaFaraTvaEUR).toFixed(2) : Number(item.valFinalaFaraTvaHUF).toFixed(2)) + " " + _toDisplayString(_ctx.offerHeader.idValuta), 1))
                        : _createCommentVNode("", true),
                      (_ctx.$q.platform.is.mobile && item.appid!='0')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 4,
                            class: _normalizeClass( item.termenLivrare == _ctx.offerHeader.termenLivrareSolicitat ? 'app__money__value--large' : 'text_termen_livrare'),
                            style: {"min-width":"110px","min-height":"25px"}
                          }, _toDisplayString(item.termenLivrare), 3))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.$q.platform.is.mobile && item.appid!='0' && !item.itemChanged)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.offerHeader.idValuta == 'RON' ? Number(item.valFinalaFaraTvaRON).toFixed(2) : _ctx.offerHeader.idValuta == 'EUR' ? Number(item.valFinalaFaraTvaEUR).toFixed(2) : Number(item.valFinalaFaraTvaHUF).toFixed(2)) + " " + _toDisplayString(_ctx.offerHeader.idValuta), 1),
                      _hoisted_70,
                      _createElementVNode("span", {
                        class: _normalizeClass( item.termenLivrare == _ctx.offerHeader.termenLivrareSolicitat ? 'app__money__value--medium' : 'text_termen_livrare')
                      }, _toDisplayString(item.termenLivrare), 3)
                    ]))
                  : _createCommentVNode("", true),
                (item.discount_proc > 0 && _ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, "-" + _toDisplayString(item.discount_proc) + " %", 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_72, [
              _createVNode(_component_q_btn, {
                icon: "add_shopping_cart",
                label: "Adauga articol in cerere",
                outline: "",
                color: "primary",
                "no-caps": "",
                onClick: _ctx.browseArticle,
                style: {"margin-top":"1rem"}
              }, null, 8, ["onClick"])
            ])
          ])
        ])),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.fixed,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.fixed) = $event)),
      "full-width": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "my_card" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                }, "Oferta " + _toDisplayString(_ctx.offerHeader.offerSlid), 3),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      "no-caps": "",
                      color: "primary",
                      onClick: _ctx.downloadPDF,
                      icon: "download",
                      style: {"margin-left":"1rem","cursor":"pointer"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_73
                      ]),
                      _: 1
                    }, 8, ["onClick"])), [
                      [_directive_ripple]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      "no-caps": "",
                      flat: "",
                      color: "primary",
                      icon: "download",
                      onClick: _ctx.downloadPDF,
                      style: {"cursor":"pointer"}
                    }, null, 8, ["onClick"])), [
                      [_directive_ripple]
                    ])
                  : _createCommentVNode("", true),
                _createVNode(_component_q_space),
                (_ctx.isLoadingOffer)
                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                      key: 2,
                      color: "black",
                      size: _ctx.$q.platform.is.mobile ? '1.5em' : '3em'
                    }, null, 8, ["size"]))
                  : _createCommentVNode("", true),
                (_ctx.isLoadingOffer)
                  ? (_openBlock(), _createBlock(_component_q_space, { key: 3 }))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 4,
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: ""
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
                  : _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 5,
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: "",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.widthPdf=300))
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
              ]),
              _: 1
            }),
            (_ctx.$q.platform.is.mobile)
              ? (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 0,
                  class: "my_card_2"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isLoadingOffer)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeWitdhPdf('in'))),
                          icon: "zoom_in",
                          style: {"margin-bottom":"8px"}
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.isLoadingOffer)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeWitdhPdf('out'))),
                          icon: "zoom_out",
                          style: {"margin-left":"10px","margin-bottom":"8px"}
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_74,
                    _createVNode(_component_vue_pdf_embed, {
                      source: _ctx.pdf,
                      width: _ctx.widthPdf
                    }, null, 8, ["source", "width"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 1,
                  class: "my_card_2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vue_pdf_embed, { source: _ctx.pdf }, null, 8, ["source"])
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}